import { TruckWithLocations } from "../lib/types/pageTypes/Analytics/TruckTypes";

export const handlePlateNumberSearch = (
  list: TruckWithLocations,
  search: string
) => {
  if (!list) return null;

  const filteredList = list.filter((truck) =>
    truck.plateNumber
      ?.replaceAll(" ", "")
      ?.toLocaleLowerCase()
      ?.includes(search?.replaceAll(" ", "")?.toLowerCase())
  );

  return filteredList;
};

export const handlePlateNumberDisplay = (plateNumber: string) => {
  if (!plateNumber || typeof plateNumber !== "string") return null;

  return plateNumber
    .replaceAll(" ", "")
    .replace(/(\d)(\D)|(\D)(\d)/g, "$1$3 $2$4")
    .toUpperCase();
};
